var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('UserNavBar'),_c('v-main',{staticClass:"ma-4"},[_c('router-view',{attrs:{"name":"users"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }